import styles from "./index.module.scss";

export default function Spotify({ id }: { id: string }): JSX.Element {
  return (
    <iframe
      className={["spotify-embed", styles.spotifyEmbed].join(" ")}
      src={`${id}?utm_source=generator`}
      width="100%"
      height="152"
    ></iframe>
  );
}
